if (typeof URL.canParse === 'undefined') {
    URL.canParse = (url, base) => {
        try {
            new URL(url, base);
            return true;
        } catch {
            return false;
        }
    };
}
